export default "__VITE_ASSET__DSLGBqFH__"